import { jsx as r, jsxs as b } from "react/jsx-runtime";
import { forwardRef as d } from "react";
import h from "../link-wrapper/link-wrapper.js";
import o from "./button.module.less.js";
const g = d(({ className: n, ...t }, e) => /* @__PURE__ */ r(i, { ref: e, className: [o.primary, n ?? ""].join(" "), ...t }));
g.displayName = "PrimaryButton";
const I = ({ className: n, ...t }) => /* @__PURE__ */ r(y, { className: [o.primary, n ?? ""].join(" "), ...t }), S = ({ className: n, ...t }) => /* @__PURE__ */ r(k, { className: [o.primary, n ?? ""].join(" "), ...t }), v = d(({ className: n, ...t }, e) => /* @__PURE__ */ r(i, { ref: e, className: [o.secondary, n ?? ""].join(" "), ...t }));
v.displayName = "SecondaryButton";
const x = ({ className: n, ...t }) => /* @__PURE__ */ r(y, { className: [o.secondary, n ?? ""].join(" "), ...t }), F = ({ className: n, ...t }) => /* @__PURE__ */ r(k, { className: [o.secondary, n ?? ""].join(" "), ...t }), C = d(({ className: n, ...t }, e) => /* @__PURE__ */ r(i, { ref: e, className: [o.outline, n ?? ""].join(" "), ...t }));
C.displayName = "OutlineButton";
const L = ({ className: n, ...t }) => /* @__PURE__ */ r(y, { className: [o.outline, n ?? ""].join(" "), ...t }), U = ({ className: n, ...t }) => /* @__PURE__ */ r(k, { className: [o.outline, n ?? ""].join(" "), ...t }), W = ({ className: n, icon: t, isDisabled: e, ariaLabel: s, onClick: a }) => /* @__PURE__ */ r(
  i,
  {
    className: [o.iconButton, o.primary, n ?? ""].join(" "),
    onClick: a,
    iconRight: t,
    isDisabled: e,
    ariaLabel: s
  }
), w = ({ className: n, icon: t, isDisabled: e, ariaLabel: s, onClick: a }) => /* @__PURE__ */ r(
  i,
  {
    className: [o.iconButton, o.secondary, n ?? ""].join(" "),
    onClick: a,
    iconRight: t,
    isDisabled: e,
    ariaLabel: s
  }
), T = ({ className: n, icon: t, isDisabled: e, ariaLabel: s, onClick: a }) => /* @__PURE__ */ r(
  i,
  {
    className: [o.iconButton, o.outline, n ?? ""].join(" "),
    onClick: a,
    iconRight: t,
    isDisabled: e,
    ariaLabel: s
  }
), _ = ({ className: n, ...t }) => /* @__PURE__ */ r(i, { className: [o.unstyled, n ?? ""].join(" "), ...t }), q = ({ className: n, ...t }) => /* @__PURE__ */ r(y, { className: [o.unstyled, n ?? ""].join(" "), ...t }), j = ({ size: n, isFullWidth: t, isDisabled: e, isLoading: s }) => [
  o.common,
  o[n],
  t ? o.fullWidth : "",
  e && !s ? o.disabled : "",
  s ? o.loading : ""
].join(" "), f = ({ iconRight: n, iconLeft: t, label: e, isFullWidth: s }) => {
  const a = !e;
  return /* @__PURE__ */ b(
    "div",
    {
      className: [
        o.labelWrapper,
        n && !a ? o.paddedIconRight : "",
        t && !a ? o.paddedIconLeft : "",
        a ? o.noPadding : "",
        s ? o.labelWrapperFullWidth : ""
      ].join(" "),
      children: [
        t && /* @__PURE__ */ r("span", { className: `${o.icon} ${a ? "" : o.iconLeft} ${t}` }),
        /* @__PURE__ */ r("div", { className: o.buttonText, children: e }),
        n && /* @__PURE__ */ r("span", { className: `${o.icon} ${a ? "" : o.iconRight} ${n}` })
      ]
    }
  );
}, y = ({
  className: n,
  size: t = "big",
  isFullWidth: e,
  isDisabled: s,
  label: a,
  iconLeft: l,
  iconRight: m,
  openInNewTab: u,
  url: c,
  decoration: N = "underline",
  onPreNavigate: p
}) => {
  const B = j({ size: t, isFullWidth: e, isDisabled: s });
  return /* @__PURE__ */ r(
    h,
    {
      onPreNavigate: p,
      className: [
        o.link,
        n ?? "",
        B,
        N === "underline" ? o.underlined : ""
      ].join(" "),
      target: u ? "_blank" : void 0,
      url: c,
      rel: "noreferrer",
      children: /* @__PURE__ */ r(f, { iconLeft: l, iconRight: m, label: a, isFullWidth: e })
    }
  );
}, k = ({
  className: n,
  size: t = "big",
  isFullWidth: e,
  label: s,
  iconLeft: a,
  iconRight: l,
  isDisabled: m,
  isLoading: u
}) => {
  const c = j({ size: t, isFullWidth: e, isDisabled: m, isLoading: u });
  return /* @__PURE__ */ r("div", { className: [o.button, o.fake, n ?? "", c].join(" "), children: /* @__PURE__ */ r(
    f,
    {
      iconLeft: u ? "ui-icon-loading" : a,
      iconRight: u ? void 0 : l,
      label: s,
      isFullWidth: e
    }
  ) });
}, i = d(
  ({ className: n, onClick: t, size: e = "big", isFullWidth: s, isDisabled: a, label: l, iconLeft: m, iconRight: u, isLoading: c, ariaLabel: N }, p) => {
    const B = j({ size: e, isFullWidth: s, isDisabled: a, isLoading: c });
    return /* @__PURE__ */ r(
      "button",
      {
        ref: p,
        type: "button",
        className: [o.button, n ?? "", B].join(" "),
        onClick: t,
        disabled: a || c,
        "aria-label": N,
        children: /* @__PURE__ */ r(
          f,
          {
            iconLeft: c ? "ui-icon-loading" : m,
            iconRight: c ? void 0 : u,
            label: l,
            isFullWidth: s
          }
        )
      }
    );
  }
);
i.displayName = "Button";
export {
  i as Button,
  k as ButtonFake,
  y as ButtonLink,
  C as OutlineButton,
  U as OutlineButtonFake,
  L as OutlineButtonLink,
  T as OutlineIconButton,
  g as PrimaryButton,
  S as PrimaryButtonFake,
  I as PrimaryButtonLink,
  W as PrimaryIconButton,
  v as SecondaryButton,
  F as SecondaryButtonFake,
  x as SecondaryButtonLink,
  w as SecondaryIconButton,
  _ as UnstyledButton,
  q as UnstyledButtonLink,
  i as default
};
